import React from 'react';
import moment from "moment";
import Select from "../../../../Common/form/select";
import './EventDatesNav.scss';

function EventDatesNav(props) {
  const  { event, eventDateSelected, handleChangeEventDate} = props;
  const dateOptions =  [];
  let dateSelected = null;
  let dateIndex = 0;

  if (!eventDateSelected) {
    dateSelected = 0;
  } else {
    dateSelected = eventDateSelected;
  }

  event.events_dates.forEach((element) => {
    let label = 'Day ' + (dateIndex+1) + ' - ' + moment(element.start_date).format("MM/DD/YYYY");
    dateOptions.push({
      id: dateIndex,
      name: label
    })
    dateIndex++;
  });

  return (
    <div className="EventDatesNav">
      <Select
        style={{option: { backgroundColor: 'white', padding: '50px' }}}
        name='dateSelector2'
        value={dateOptions[dateSelected]}
        options={dateOptions}
        defaultClass='EventDates-selector'
        onChange={handleChangeEventDate}
      />
    </div>
  )
}

export default EventDatesNav;
